<template>
  <div class="log-in">
    <el-dialog
      title="退出登录"
      :visible.sync="login_state.is_show_logout"
      width="30%"
    >
      <span>确定退出登录？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="logoutCancelFn">取 消</el-button>
        <el-button type="primary" @click="logoutFn">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :visible.sync="login_state.is_show_dialog"
      width="420px"
      center
      :show-close="closeOnClickModal"
      :close-on-click-modal="false"
      :before-close="dialogClear"
    >
      <div class="tc log-logo" slot="title">
        <img :src="login_log" style="width: 50%;" alt />
      </div>
      <div class="log-body bind-mobile" v-if="login_state.is_show_bind_mobile">
        <div class="bind-des">
          <p class="bind-title">
            <i class="iconfont iconshouji"></i>
            绑定手机号
          </p>
          <p class="bind-text">为保证您的账号安全，请先验证手机</p>
        </div>
        <el-form
          :model="ruleBindForm"
          :rules="bindRules"
          ref="ruleBindForm"
          label-width="0"
        >
          <el-form-item prop="mobile">
            <el-input
              type="text"
              v-model="ruleBindForm.mobile"
              placeholder="请输入手机号"
              clearable
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item prop="code">
            <el-input placeholder="请输入验证码" v-model="ruleBindForm.code">
              <template slot="append">
                <div class="img-code" @click="refreshCodeFn">
                  <img :src="code_config.url + code_config.sign" alt />
                </div>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item prop="sms">
            <el-input
              placeholder="请输入短信码"
              v-model="ruleBindForm.sms"
              @keyup.native.enter="bindMobileForm('ruleBindForm')"
            >
              <template slot="append">
                <el-button
                  :type="sms_config.loading ? '' : 'primary'"
                  @click="validSms('ruleBindForm')"
                  >{{ sms_config.text }}
                </el-button>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item>
            <div class="tc log-btn">
              <el-button
                type="primary"
                @click="bindMobileForm('ruleBindForm')"
                :loading="bind_mobile_state.loading"
                >登录
              </el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="log-body log-box" v-else>
        <ul class="log-tabs">
          <li
            :class="{ active: login_state.login_way == item.key }"
            v-for="(item, index) in tabs_data.title"
            :key="index"
            @click="tabsChangeFn(item)"
          >
            <i class="iconfont" :class="item.icon"></i>
            <span>{{ item.name }}</span>
          </li>
        </ul>
        <div class="log-content">
          <div
            v-loading="img_config.loading"
            v-if="login_state.login_way == 'wechat'"
          >
            <div class="qrcode-box">
              <!-- <vue-qr
                :text="qr_config.text"
                :size="qr_config.size"
                :margin="qr_config.margin"
              ></vue-qr> -->
              <el-image :src="'data:image/png;base64,' + img_config.url">
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </div>
            <div class="log-des">
              <p class="des-title" v-if="img_config.err_msg">
                <span>{{ img_config.err_msg }}</span>
                <a href="javascript:;" @click="refreshQrFn">刷新二维码</a>
              </p>
              <p class="des-title">
                微信扫一扫，快速登录&nbsp;
                <a href="javascript:;" @click="refreshQrFn">刷新</a>
              </p>
            </div>
          </div>
          <!-- <div v-if="login_state.login_way == 'verificationCode'">
            <div class="tips">首次验证通过即注册云校招账号</div>
            <el-form
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              label-width="0"
              class="demo-ruleForm"
            >
              <el-form-item prop="mobile">
                <el-input
                  type="text"
                  v-model="ruleForm.mobile"
                  placeholder="请输入手机号"
                  clearable
                  autocomplete="off"
                ></el-input>
              </el-form-item>
              <el-form-item prop="code">
                <el-input
                  placeholder="请输入验证码"
                  v-model="ruleForm.code"
                  @keyup.native.enter="codeEnterFn"
                >
                  <template slot="append">
                    <div class="img-code" @click="refreshCodeFn">
                      <img :src="code_config.url + code_config.sign" alt />
                    </div>
                  </template>
                </el-input>
              </el-form-item>
              <el-form-item prop="sms">
                <el-input
                  placeholder="请输入短信码"
                  v-model="ruleForm.sms"
                  @keyup.native.enter="submitForm('ruleForm')"
                >
                  <template slot="append">
                    <el-button
                      :type="sms_config.loading ? '' : 'primary'"
                      @click="validSms('ruleForm')"
                      >{{ sms_config.text }}
                    </el-button>
                  </template>
                </el-input>
              </el-form-item>

              <p class="form-tip">
                <el-checkbox v-model="agreeProtocol"></el-checkbox>
                同意云校招
                <el-link
                  type="primary"
                  :underline="false"
                  href="https://m.bysjy.com.cn/student/kzp/user_agree.html?token=yunyan1536161856"
                  target="_blank"
                >
                  《用户协议》
                </el-link>
                <el-link
                  type="primary"
                  :underline="false"
                  href="https://m.bysjy.com.cn/student/kzp/privacy.html?token=yunyan1536161856"
                  target="_blank"
                >
                  《隐私协议》
                </el-link>
              </p>

              <el-form-item style="margin-top:-10px">
                <div class="tc log-btn">
                  <el-button
                    type="primary"
                    @click="submitForm('ruleForm')"
                    :loading="submit_state.loading"
                    >登录/注册
                  </el-button>
                </div>
              </el-form-item>
            </el-form>
          </div> -->
          <div v-else>
            <el-form
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              label-width="0"
              class="demo-ruleForm"
            >
              <el-form-item prop="mobile">
                <el-input
                  type="text"
                  v-model="ruleForm.mobile"
                  placeholder="请输入手机号"
                  clearable
                  autocomplete="off"
                ></el-input>
              </el-form-item>
              <el-form-item prop="password" v-if="log_type.value != 'sms'">
                <el-input
                  placeholder="请输入密码"
                  v-model="ruleForm.password"
                  type="password"
                  maxlength="100"
                  autocomplete="off"
                  @keyup.native.enter="submitForm('ruleForm')"
                >
                  <div slot="suffix">
                    <!-- 忘记密码 -->
                    <el-popover
                      placement="bottom"
                      v-model="visible"
                      trigger="hover"
                    >
                      <div class="pwd-tips">
                        <!-- <span class="scan-code" @click="scanCode">
                          使用微信扫码登录
                        </span> -->
                        <span
                          class="retrieve-password"
                          @click="retrievePasswordFnc"
                        >
                          找回密码
                        </span>
                      </div>
                      <span
                        class="input-suffix-txt forgot-password"
                        slot="reference"
                      >
                        忘记密码
                      </span>
                    </el-popover>
                  </div>
                </el-input>
              </el-form-item>

              <p class="form-tip">
                <el-checkbox v-model="agreeProtocol"></el-checkbox>
                同意云校招
                <el-link
                  type="primary"
                  :underline="false"
                  href="https://m.bysjy.com.cn/student/kzp/user_agree.html?token=yunyan1536161856"
                  target="_blank"
                >
                  《用户协议》
                </el-link>
                <el-link
                  type="primary"
                  :underline="false"
                  href="https://m.bysjy.com.cn/student/kzp/privacy.html?token=yunyan1536161856"
                  target="_blank"
                >
                  《隐私协议》
                </el-link>
              </p>

              <el-form-item style="margin-top:-10px">
                <div class="tc log-btn">
                  <el-button
                    type="primary"
                    @click="submitForm('ruleForm')"
                    :loading="submit_state.loading"
                    >登录
                  </el-button>
                </div>
              </el-form-item>
            </el-form>
          </div>

          <!-- <div class="log-des">
            <p class="des-text" style="margin-top: 20px">
              <a href="javascript:;" @click.stop.prevent="goRegisterFn">
                立即注册
              </a>
            </p>
          </div> -->
        </div>
      </div>
      <!-- <span slot="footer" class="dialog-footer">
              <el-button @click="cancelFn()">取 消</el-button>
            </span>-->
    </el-dialog>
    <!-- 切换成注册账号面板 -->
    <!-- 找回密码面板 -->
    <el-dialog
      :visible.sync="login_state.is_retrieve_dialog"
      width="420px"
      center
      :show-close="closeOnClickModal"
      :close-on-click-modal="false"
      :before-close="dialogClear"
    >
      <div class="tc log-logo" slot="title">
        <img :src="login_log" style="width: 50%;" alt />
      </div>
      <retrieve-password />
    </el-dialog>
  </div>
</template>

<script>
// https://www.npmjs.com/package/vue-qr
import VueQr from "vue-qr";
import retrievePassword from "./components/retrieve-password";

import { mapState } from "vuex";

export default {
  name: "log-in",
  components: {
    VueQr,
    retrievePassword
  },
  props: {
    closeOnClickModal: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapState({
      login_state: state => state.login_state
    })
  },
  data() {
    let reg = {
      mobile: /^0?(1[1-9])[0-9]{9}$/,
      code: /^\d{6}$/,
      password: /^[a-zA-Z0-9]{6,16}$/,
      passReg: /^(?=.*[a-zA-Z\d])(?=.*[a-zA-Z$@$#!%*?&])(?=.*[\d$@$#!%*?&])[A-Za-z\d$@$#!%*?&]{8,}/,
      imgCode: /^\d{4}$/,
      tel: /[0-9-()（）]{7,18}/,
      email: /\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/
    };

    let validateMobile = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入手机号"));
      } else if (!reg.mobile.test(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    };

    let validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else if (!reg.passReg.test(value)) {
        callback(new Error("密码格式不对，请重新输入"));
      } else {
        callback();
      }
    };

    let rulesObj = {
      password: [
        { required: true, message: "请输入密码", trigger: "blur" },
        { min: 8, message: "密码长度必须大于8位", trigger: "blur" }
      ],
      mobile: [
        { required: true, message: "请输入手机号", trigger: "blur" },
        { validator: validateMobile, trigger: "blur" }
      ],
      code: [
        { required: true, message: "请输入验证码", trigger: "blur" },
        { min: 4, message: "请输入正确的验证码", trigger: "blur" }
      ],
      sms: [
        { required: true, message: "请输入短信码", trigger: "blur" },
        { min: 6, message: "请输入正确的短信码", trigger: "blur" }
      ],
      passReg: [
        { required: true, message: "请输入密码", trigger: "blur" },
        // { min: 8, message: "密码长度必须大于等于8位", trigger: "blur" },
        // { max: 16, message: "密码长度必须小于等于16位", trigger: "blur" },
        { validator: validatePass, trigger: "blur" }
      ]
    };

    return {
      code_config: {
        url: "",
        sign: ""
      },
      login_log: "https://o.bysjy.com.cn/kzp/public/yunB.png",
      tabs_data: {
        title: [
          {
            name: "微信注册/登录",
            icon: "iconweixin",
            key: "wechat"
          },
          // {
          //   name: "验证码注册/登录",
          //   icon: "iconwodedangxuan",
          //   key: "verificationCode"
          // },
          {
            name: "账号/密码登录",
            icon: "iconwodedangxuan",
            key: "account"
          }
        ]
      },
      visible: false, //控制忘记密码提示框
      agreeProtocol:
        localStorage.getItem("agree_storage_key") === "1" ? true : false, // 同意云校招的协议状态
      qr_config: {
        timer: null,
        loading: true,
        text: "",
        size: 180,
        margin: 0,
        dotScale: 0.5,
        whiteMargin: true,
        colorDark: "#000000",
        colorLight: "#ffffff",
        expire_seconds: 5000,
        ticket: ""
      },
      img_config: {
        url: "",
        uuid: "",
        timer: null,
        loading: true,
        err_msg: ""
      },
      sms_config: {
        text: "获取短信码",
        times: 60,
        timer: null,
        loading: false
      },
      log_type: {
        data: [
          { name: "验证码登录", value: "sms" },
          { name: "密码登录", value: "password" }
        ],
        value: "password" // password/code
      },
      ruleForm: {
        password: "",
        mobile: "",
        code: "",
        sms: ""
      },
      rules: {
        password: rulesObj.password,
        mobile: rulesObj.mobile,
        code: rulesObj.code,
        sms: rulesObj.sms
      },

      submit_state: {
        loading: false,
        err_msg: ""
      },

      // 绑定手机号码
      bind_mobile_state: {
        loading: false,
        err_msg: ""
      },
      ruleBindForm: {
        mobile: "",
        code: "",
        sms: ""
      },
      bindRules: {
        mobile: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { validator: validateMobile, trigger: "blur" }
        ],
        code: [
          { required: true, message: "请输入验证码", trigger: "blur" },
          { min: 4, message: "请输入正确的验证码", trigger: "blur" }
        ],
        sms: [
          { required: true, message: "请输入短信码", trigger: "blur" },
          { min: 6, message: "请输入正确的短信码", trigger: "blur" }
        ]
      }
      // registerShow: false,
      // registerChecked: false,
      // retrieveShow: false //修改密码弹窗
    };
  },
  watch: {
    login_state: {
      deep: true, //深度监听设置为 true
      handler: function(newV, oldV) {
        console.log("watch中：", newV);
      }
    }
  },
  created: function() {
    this.code_config.url =
      this.$util.ajaxUrl + "index.php?r=kzp_website/ajax_img_code&sign=";
  },
  mounted() {
    this.dialogClear();
    // this.triggerTabsChangeFn(this.login_state.login_way);
  },
  methods: {
    // 点击进入微信扫码登录
    scanCode() {
      // 直接调用切换登录方法
      let value = {
        name: "微信注册/登录",
        icon: "iconweixin",
        key: "wechat"
      };
      this.tabsChangeFn(value);
      this.visible = false; //关闭提示
    },
    //进入找回密码页面
    retrievePasswordFnc() {
      this.$store.commit("changeLoginState", [
        {
          key: "is_show_dialog",
          value: false
        },
        {
          key: "is_retrieve_dialog",
          value: true
        }
      ]); //关闭登录弹窗并打开修改密码弹窗
    },
    // 在code码框按下enter键
    codeEnterFn: function() {
      if (this.log_type.value != "sms") {
        this.submitForm("ruleForm");
      }
    },

    dialogClear: function(done) {
      this.clearCheckScan();
      typeof done === "function" ? done() : null;
    },
    refreshCodeFn: function() {
      let _self = this;
      this.$util.get("kzp_website", "img_url", {}).then(function(res) {
        let data = res.data,
          code = res.code;

        if (code == 1 && data.sign) {
          _self.code_config.sign = data.sign;
        }
      });
    },
    resetForm: function(formName) {
      this.$refs[formName].resetFields();
    },
    clearValidate: function(formName) {
      this.$refs[formName].clearValidate();
    },
    bindMobileForm: function(formName) {
      let ruleBindForm = this.ruleBindForm;
      let that = this;

      this.$refs[formName].validate(function(valid, res) {
        // console.log("valid", valid, res);
        let must_key, method;
        must_key = ["mobile", "sms", "code"];
        let params = {
          mobile: "",
          code: "",
          sms: ""
        };

        for (let index in must_key) {
          let key = must_key[index];
          if (res && res[key]) {
            return false;
          }
          params[key] = ruleBindForm[key];
        }

        that.bindFn(params);
      });
    },
    bindFn: function(params) {
      let _self = this;

      let codeSign = this.code_config.sign;
      if (!codeSign) {
        _self.$message.error("图形码无效");
        this.refreshCodeFn();
        return;
      }

      let ticket = _self.qr_config.ticket;
      if (!ticket) {
        _self.$message.error("请先扫二维码");
        _self.$store.commit("changeLoginState", {
          key: "is_show_bind_mobile",
          value: false
        });
      }

      params.ticket = ticket;

      this.bind_mobile_state.loading = true;
      this.$util.post("kzp_website", "bind_mobile", params).then(function(res) {
        _self.bind_mobile_state.loading = false;

        let data = res.data,
          code = res.code;
        if (code == 1) {
          _self.logSuccessFn(data);
        } else {
          let err_msg = res.msg || "绑定失败";
          _self.$message.error(err_msg);
        }
      });
    },
    submitForm: function(formName) {
      let log_type = this.log_type.value;
      let ruleForm = this.ruleForm;
      let that = this;
      if (!that.agreeProtocol) {
        that.$message.error("请先勾选同意云校招《用户协议》《隐私协议》");
        return;
      }

      this.$refs[formName].validate(function(valid, res) {
        // console.log("valid", valid, res);
        let must_key, method;
        if (log_type == "sms") {
          // 短信登录
          must_key = ["mobile", "sms", "code"];
          method = "login";
        } else {
          // 密码登录
          must_key = ["mobile", "password"];
          method = "password_login";
        }

        let params = {
          password: "",
          // code: "",
          mobile: ""
          // sms: ""
        };

        for (let index in must_key) {
          let key = must_key[index];
          if (res && res[key]) {
            return false;
          }
          params[key] = ruleForm[key];
        }

        that.loginFn(method, params);
      });
    },
    /**
     * 登录成功
     */
    logSuccessFn: function(data) {
      let _self = this;

      // 判断是否注销账户
      if (data.is_cancel_temp * 1 == 1) {
        this.isInsistOff(data);
        return;
      }
      // 保存登录sign
      _self.$util.setSign(data.sign);
      // 保存用户信息
      let keys = "kzp_user_info";
      let user = data.user;
      sessionStorage.setItem(keys, JSON.stringify(user));

      _self.$util.tansPics(user, "user_header");
      _self.$store.commit("changeUser", { data: user });
      _self.$store.commit("changeLoginState", {
        key: "is_show_dialog",
        value: false
      });
      // 通知当前页面
      _self.$emit("logined", { user: user, code: 1 });
      //登陆成功后校验用户基本信息
      if (data.resume == "upload") localStorage.setItem("login_code", 1);
      this.isDefaultResume(); //是否存在默认简历
    },
    /**
     * 是否存在默认简历
     */
    isDefaultResume() {
      this.$util.get("kzp_person", "check_default_resume", {}).then(res => {
        let { code, data } = res;
        if (code === 1) {
          //处理数据
          let login_code = localStorage.getItem("login_code") || "";
          if (!data) {
            //无简历，给出提示 完善信息
            window.location.href = "/seeker/register.html";
          } else if (login_code * 1 == 1) {
            localStorage.removeItem("login_code");
            localStorage.setItem("showDialog", 1);
            window.location.href = "/seeker/person.html";
          }
        }
      });
    },
    /**
     * 是否坚持注销
     */
    isInsistOff(data) {
      // 刷新二维码
      this.clearCheckScan();
      this.refreshQrFn();
      this.refreshCodeFn();
      this.$confirm(
        "您当前账号已申请注销，当前处于冷静期，" +
          data.cancel_time +
          "日后平台将清除您的所有个人信息，您是否考虑取消注销？",
        "提示",
        {
          distinguishCancelAndClose: true,
          confirmButtonText: "取消注销",
          cancelButtonText: "暂不考虑"
        }
      )
        .then(() => {
          //提交取消注销
          this.$util
            .get("kzp_person", "cancel_logout", { student_id: data.student_id })
            .then(res => {
              if (res.code == 1) {
                this.$message.success("取消成功，请重新登录~");
              } else {
                this.$message.error(res.msg || "操作失败");
              }
            });
        })
        .catch(() => {
          //仍然注销，移除登录sign
          this.logoutFn("isInsistOff");
        });
    },

    // 账号密码登录
    loginFn: function(method, params) {
      let _self = this;

      // let codeSign = this.code_config.sign;
      // if (!codeSign) {
      //   _self.$message.error("图形码无效");
      //   this.refreshCodeFn();
      //   return;
      // }

      // params.codeSign = codeSign;

      this.submit_state.loading = true;
      this.$util.post("kzp_website", method, params).then(function(res) {
        _self.submit_state.loading = false;

        let data = res.data,
          code = res.code;
        if (code == 1) {
          _self.logSuccessFn(data);
        } else {
          let err_msg = res.msg || "登录失败";
          _self.$message.error(err_msg);

          // 刷新验证码
          _self.refreshCodeFn();
        }
      });
    },
    logTypeChangeFn: function(item) {
      this.log_type.value = item.value;
      this.clearValidate("ruleForm");
    },
    cancelFn: function() {
      this.$store.commit("changeLoginState", {
        key: "is_show_dialog",
        value: false
      });
    },
    tabsChangeFn: function(item) {
      let value = item.key;
      // value === "verificationCode" ? this.log_type.value = 'sms' : this.log_type.value = 'password'
      // this.clearValidate("ruleForm");
      this.$store.commit("changeLoginState", {
        key: "login_way",
        value: value
      });
      this.triggerTabsChangeFn(value);
    },
    triggerTabsChangeFn: function(value) {
      this.clearCheckScan();
      if (value == "wechat") {
        // 刷新二维码
        this.refreshQrFn();
      } else {
        this.refreshCodeFn();
      }
    },
    // 刷新二维码
    refreshQrFn: function() {
      let _self = this;
      if (
        !_self.login_state.is_show_dialog ||
        _self.login_state.is_show_bind_mobile
      ) {
        // 当前在绑定手机号码，不需要刷新二维码
        return;
      }

      // 关闭轮询
      _self.clearCheckScan();
      _self.img_config.url = ""; // 清空生成二维码
      _self.img_config.loading = true;
      // 刷新二维码
      this.$util
        .get("kzp_website", "create_mini_program", {})
        .then(function(res) {
          _self.img_config.loading = false;

          let data = res.data,
            code = res.code;
          if (code == 1) {
            // let ticket = data.ticket,
            //   expire_seconds = data.expire_seconds,
            //   url = data.url;

            // _self.qr_config.text = url;
            // _self.qr_config.ticket = ticket;
            // _self.qr_config.expire_seconds = expire_seconds;
            // _self.qr_config.current_seconds = new Date().getTime()
            _self.img_config.url = data.url;
            _self.img_config.uuid = data.uuid;
            _self.checkScan();
          } else {
            let err_msg = res.msg || "获取二维码失败";
            _self.img_config.err_msg = err_msg;
          }
        });
    },
    // 轮询 是否有扫码
    checkScan: function() {
      let _self = this;
      _self.clearCheckScan();

      // 检查是否已扫码
      let uuid = _self.img_config.uuid;
      // if (!ticket) {
      //   console.log("ticket无效...");
      //   _self.qr_config.err_msg = "无效的二维码";
      //   return;
      // }

      // let current_seconds = _self.qr_config.current_seconds;
      // let expire_seconds = _self.qr_config.expire_seconds;
      // let now_seconds = new Date().getTime();
      // // 当过期了
      // if (now_seconds - current_seconds >= expire_seconds * 1000) {
      //   console.log("过期了...");
      //   _self.qr_config.err_msg = "二维码已失效";
      //   return;
      // }
      if (!_self.img_config.url) {
        console.log("图片正在加载中...");
        return;
      }

      if (!_self.login_state.is_show_dialog) {
        console.log("dialog已经关掉了");
        return;
      }

      this.$util
        .get("kzp_website", "check_mini_program", { uuid })
        .then(function(res) {
          let data = res.data,
            code = res.code;
          if (code == 1) {
            if (data === "bind_mobile") {
              // 进入绑定手机号
              _self.$store.commit("changeLoginState", {
                key: "is_show_bind_mobile",
                value: true
              });
            } else if (data === true) {
              _self.img_config.timer = setTimeout(function() {
                _self.checkScan();
              }, 1000);
            } else if (data) {
              // 登录成功
              _self.logSuccessFn(data);
            }
          } else {
            let err_msg = res.msg || "二维码已失效";
            _self.img_config.err_msg = err_msg;
          }
        });
    },
    // 关闭轮询
    clearCheckScan: function() {
      let _self = this;
      clearTimeout(_self.img_config.timer);
    },

    // 短信码发送条件验证
    validSms: function(formName, type) {
      let _self = this;
      if (_self.sms_config.loading) {
        return;
      }

      let params = {
        mobile: "",
        code: "",
        sms: ""
      };

      let codeSign = this.code_config.sign;
      if (!codeSign) {
        _self.$message.error("图形码无效");
        this.refreshCodeFn();
        return;
      }

      params.codeSign = codeSign;

      let ruleForm = this[formName] ? this[formName] : this.ruleBindForm;
      this.$refs[formName].validate(function(valid, res) {
        // console.log("valid", valid, res);
        let must_key, method;
        must_key = ["mobile", "code"];

        for (let index in must_key) {
          let key = must_key[index];
          if (res && res[key]) {
            return false;
          }
          params[key] = ruleForm[key];
        }

        if (type) {
          params["type"] = type;
        } else {
          params["type"] = 0;
        }

        _self.sendSmsFn(params);
      });
    },
    // 发送短信码
    sendSmsFn: function(params) {
      let _self = this;
      if (_self.sms_config.loading) {
        return;
      }

      let clearFn = function() {
        clearInterval(_self.sms_config.timer);
        _self.sms_config.text = "获取短信码";
        _self.sms_config.times = 90;
        _self.sms_config.loading = false;
      };
      clearFn();

      let cycleFn = function() {
        if (_self.sms_config.times <= 0) {
          clearFn();
        } else {
          --_self.sms_config.times;
          _self.sms_config.text = _self.sms_config.times + "s";
        }
      };

      _self.sms_config.loading = true;
      cycleFn();
      _self.sms_config.timer = setInterval(cycleFn, 1000);

      this.$util
        .post("kzp_website", "send_mobile_sms", params)
        .then(function(res) {
          let data = res.data,
            code = res.code;
          if (code == 1) {
            // 提示短信已经发送
            _self.$message({
              message: "短信已成功发送至手机:" + params.mobile,
              type: "success"
            });
          } else {
            // 刷新图形码
            _self.refreshCodeFn();

            clearFn();
            let err_msg = res.msg || "短信发送失败!";
            _self.$message.error(err_msg);
          }
        });
    },

    // 登出
    logoutCancelFn: function() {
      this.$store.commit("changeLoginState", {
        key: "is_show_logout",
        value: false
      });
    },
    logoutFn: function(type) {
      let _self = this;
      this.$util.post("kzp_website", "logout").then(function(res) {
        let code = res.code,
          data = res.data;
        if (code === 1) {
          sessionStorage.setItem("kzp_user_info", "");
          if (type != "isInsistOff") {
            _self.logoutCancelFn();
            // _self.$util.errorFn('请登录!')
            location.href = "/seeker/";
          }
        }
      });
    },

    //去注册
    // goRegisterFn() {
    //   // 刷新验证码
    //   this.refreshCodeFn();
    //   this.login_state.is_show_dialog = false;
    //   this.registerShow = true;
    // },

    goLoginFn() {
      this.login_state.is_show_dialog = true;
      // this.registerShow = false;
    },
    validPass(password) {
      let that = this;
      // 密码格式校验
      let pass_reg = /^[a-zA-Z0-9]{8,16}$/;
      let err_msg = "";
      if (pass_reg.test(password)) {
        // 全由数字组成
        let pass_reg_int = /^[0-9]{8,16}$/;
        let pass_reg_str = /^[a-zA-Z]{8,16}$/;
        if (pass_reg_int.test(password) || pass_reg_str.test(password)) {
          err_msg = "密码必须包含数字、大小写字母";
        }
      } else {
        if (password.length < 8 || password.length > 16) {
          err_msg = "密码长度须为8~16个字符";
        } else {
          err_msg = "密码只能由数字、大小写字母组成";
        }
      }

      if (err_msg) {
        that.$message.error(err_msg);
        return false;
      }

      return true;
    }
  },
  watch: {
    "login_state.is_show_dialog": {
      handler: function(newVal, oldVal) {
        this.dialogClear();
        if (newVal) {
          this.triggerTabsChangeFn(this.login_state.login_way);
        }
      },
      deep: true
    },
    agreeProtocol(newVal) {
      newVal
        ? localStorage.setItem("agree_storage_key", "1")
        : localStorage.setItem("agree_storage_key", "0");
    }
  }
};
</script>

<style lang="scss" scoped>
.log-in {
  .el-form-item {
    // margin-bottom: 15px;
  }

  .login-type {
    padding: 0 0 0 15px;
    margin-bottom: 30px;

    span {
      font-size: 14px;
      line-height: 20px;
      cursor: pointer;
    }

    .login-type-text {
      color: $lightColor;
      display: none;
    }

    .active {
      display: inline-block;
    }
  }

  .log-btn {
    .el-button.el-button--primary {
      height: 50px;
      width: 100%;
      font-size: 16px;
      margin: 0 auto;
    }
  }

  .log-logo {
    padding: 30px 0 0;
  }

  .log-body {
    padding: 0 15px;
  }

  ul.log-tabs {
    // display: flex;
    overflow: hidden;
    // border-bottom: 1px solid #ececec;

    > li {
      float: left;
      width: 50%;
      font-size: 16px;
      color: #999999;
      line-height: 22px;
      text-align: center;
      padding: 15px 0;
      cursor: pointer;

      border-bottom: 2px solid #f3f3f3;

      .iconfont {
        margin-right: 5px;
      }

      &.active {
        color: #525252;
        border-bottom-color: #007fff;
      }
    }
  }

  .log-content {
    padding: 40px 0 0;
    .form-tip {
      margin: -5px 0px 40px;
    }
  }

  .qrcode-box {
    width: 200px;
    height: 200px;
    margin: 0 auto 10px;
    // padding: 10px;
    border: 1px solid #efefef;
    @include border-radius(10px);
    @include box-sizing(border-box);

    img {
      width: 100%;
      height: 100%;
    }
  }

  .log-des {
    text-align: center;

    p {
      margin-bottom: 10px;
    }

    .des-title {
      font-size: 14px;
      color: #525252;
      line-height: 20px;
    }

    .des-text {
      font-size: 12px;
      line-height: 17px;
      color: #999999;
    }

    a {
      color: #007fff;
    }
  }

  .img-code {
    margin: 0 -20px;
    cursor: pointer;

    img {
      height: 100%;
      max-width: none;
    }
  }

  .bind-mobile {
    .bind-des {
      margin-bottom: 47px;
      font-weight: 500;
      text-align: center;

      .bind-title {
        font-size: 16px;
        color: #525252;
        line-height: 22px;
        margin-bottom: 5px;
      }

      .bind-text {
        font-size: 14px;
        color: #999;
        line-height: 20px;
      }
    }
  }
}
</style>
<style lang="scss">
.log-in {
  .el-input__suffix {
    right: 10px;
    .forgot-password {
      cursor: pointer;
      &:hover {
        color: #007fff;
      }
    }
  }
  .el-image {
    width: 100%;
    height: 100%;
    .image-slot {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 40px;
    }
  }
}
.pwd-tips {
  display: flex;
  flex-direction: column;
  cursor: pointer;
  span {
    color: #999;
    &:hover {
      color: #007fff;
    }
    &.scan-code {
      margin-bottom: 10px;
    }
  }
}
.tips {
  text-align: center;
  color: #999;
  margin-bottom: 22px;
}
</style>



// WEBPACK FOOTER //
// src/components/Login/Login.vue